import { Cell, Pie, PieChart, Tooltip } from "recharts";
import { money } from "@/lib/format";

const COLORS = ["#0072C6", "#0EA5E9", "#10B981", "#F5B70A", "#334155", "#94A3B8", "#E11D48", "#84CC16", "#7C93B5", "#F97316"];

export const Donut = ({ data, currency, size = 150, testId = "donut-chart" }) => {
  const rows = data.filter((d) => d.value > 0);
  if (!rows.length) return <p className="text-xs text-slate-400">No data entered</p>;
  const total = rows.reduce((a, d) => a + d.value, 0);
  return (
    <div className="flex items-center gap-4" data-testid={testId}>
      <PieChart width={size} height={size}>
        <Pie data={rows} dataKey="value" innerRadius={size * 0.3} outerRadius={size * 0.48} paddingAngle={2} stroke="none" isAnimationActive={false}>
          {rows.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
        </Pie>
        <Tooltip formatter={(v) => money(v, currency)} />
      </PieChart>
      <ul className="space-y-1 text-xs flex-1">
        {rows.map((d, i) => (
          <li key={d.name} className="flex items-center justify-between gap-2">
            <span className="flex items-center gap-1.5 text-slate-600"><i className="h-2 w-2 rounded-full inline-block" style={{ background: COLORS[i % COLORS.length] }} />{d.name}</span>
            <span className="font-mono text-slate-800">{((d.value / total) * 100).toFixed(0)}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const IncomeBars = ({ sources, goal, currency }) => {
  const expected = sources.reduce((a, [, v]) => a + v, 0);
  const max = Math.max(goal, expected, 1);
  return (
    <div className="space-y-1.5" data-testid="retirement-income-chart">
      <div className="flex h-4 w-full rounded overflow-hidden bg-slate-100">
        {sources.map(([k, v], i) => <div key={k} style={{ width: `${(v / max) * 100}%`, background: COLORS[i % COLORS.length] }} title={`${k}: ${money(v, currency)}`} />)}
      </div>
      <div className="relative h-1.5 w-full rounded bg-slate-100"><div className="absolute h-1.5 rounded bg-slate-900" style={{ width: `${(goal / max) * 100}%` }} /></div>
      <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-[10.5px] text-slate-500">
        {sources.map(([k], i) => <span key={k} className="flex items-center gap-1"><i className="h-2 w-2 rounded-full inline-block" style={{ background: COLORS[i % COLORS.length] }} />{k}</span>)}
        <span className="flex items-center gap-1"><i className="h-2 w-2 rounded-full inline-block bg-slate-900" />Goal {money(goal, currency)}</span>
      </div>
    </div>
  );
};
